// From https://github.com/foxhound87/mobx-react-form-demo/blob/master/src/components/forms/FormRegisterSimple.jsx
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Redirect, Link } from 'react-router-dom';
import { observer, inject } from 'mobx-react';

import Input from './inputs/SimpleInput';
// import Checkbox from './inputs/SimpleCheckbox';
// import FormControls from './controls/FormControls';

// export default inject('auth')(observer(({ auth, form }) => (
@inject('auth')
@observer
class FormSignup extends Component {
    render() {
        const { auth, form } = this.props;

        return (
            <form
                className="form-signin"
                onSubmit={(e) =>
                    form.onSubmit(e, {
                        onSuccess: auth.onSignupSubmit,
                        onError: auth.onErrorSubmit,
                    })
                }
            >
                <h4>Start with your account today.</h4>
                <hr />
                <Input field={form.$('company')} />
                <Input field={form.$('firstname')} />
                <Input field={form.$('lastname')} />
                <hr />
                <Input field={form.$('email')} />
                <Input field={form.$('password')} type="password" />
                <hr />
                <div className="form-check">
                    <input type="checkbox" className="form-check-input" id="termsPrivacyCheck" />
                    <label className="form-check-label" for="termsPrivacyCheck">
                        I agree to the{' '}
                        <Link to="/terms" className="">
                            Terms of Service
                        </Link>{' '}
                        and{' '}
                        <Link to="/privacy" className="">
                            Privacy Policy
                        </Link>
                        .
                    </label>
                </div>

                <hr />
                <div className="text-center">
                    {auth.isLoggedIn && !auth.isLoggingIn && <Redirect to="/home" /> // Redirecting to home if logged in !
                    }

                    <button
                        className={`btn btn-primary${!form.isValid ? '' : ''}`}
                        type="submit"
                        onClick={(e) =>
                            form.onSubmit(e, {
                                onSuccess: auth.onSignupSubmit,
                                onError: auth.onErrorSubmit,
                            })
                        }
                    >
                        <FormattedMessage id="Login.SignUp" defaultMessage="Sign Up" />
                    </button>
                    <p>
                        <small>{form.error}</small>
                    </p>
                    <p>
                        <small>
                            <FormattedMessage
                                id="Login.AlreadyHaveAnAccount"
                                defaultMessage="Already have an account"
                            />
                            <Link to="/login" className="btn btn-sm btn-secondary ml-2">
                                <FormattedMessage id="Login.Login" defaultMessage="Login" />
                            </Link>
                        </small>
                    </p>
                </div>
            </form>
        );
    }
}

FormSignup.wrappedComponent.propTypes = {
    auth: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
};

export default injectIntl(FormSignup);
